import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { rawFetch } from "@/lib/api/client";
import { PageHeader, ErrorBox, DataTable } from "@/components/common";
import { useApp } from "@/lib/store";
import { shortId } from "@/lib/utils";

interface Workspace { id: string; name: string; slug: string; organization: string;
                       accent_color?: string; logo_url?: string }

export function Workspaces() {
  const setWorkspaces = useApp((s) => s.setWorkspaces);
  const setWorkspace = useApp((s) => s.setWorkspace);
  const current = useApp((s) => s.workspaceId);

  const q = useQuery<{ results: Workspace[] }>({
    queryKey: ["workspaces"],
    queryFn: () => rawFetch("/iam/workspaces/?page_size=100"),
    retry: false,
  });

  useEffect(() => {
    if (q.data?.results) setWorkspaces(q.data.results.map(
      (w) => ({ id: w.id, name: w.name, slug: w.slug,
                accent_color: w.accent_color, logo_url: w.logo_url })));
  }, [q.data, setWorkspaces]);

  return (
    <>
      <PageHeader title="Workspaces" subtitle="Multi-tenant scopes (one schema per organization)." />
      {q.isError && <ErrorBox error={q.error} />}
      <DataTable
        rows={q.data?.results ?? []}
        cols={[
          { header: "Name", cell: (w) => <div>
              <div>{w.name}</div>
              <div className="text-xs text-muted">{w.slug}</div>
            </div> },
          { header: "ID", cell: (w) => <code className="font-mono text-xs">{shortId(w.id)}</code> },
          { header: "Org", cell: (w) => <code className="font-mono text-xs">{shortId(w.organization)}</code> },
          { header: "", width: "1%", cell: (w) => (
              <button
                className={current === w.id ? "btn-primary" : "btn"}
                onClick={() => setWorkspace(w.id)}>
                {current === w.id ? "Active" : "Select"}
              </button>
            ),
          },
        ]}
        empty="No workspaces yet — create one in /admin/."
      />
    </>
  );
}
